import { create } from 'zustand';
import { MedicinesInteractions } from '../interfaces/medicine-drug-interactions';
import { PrescriptionInteractionJustifyDetail } from '../containers/prescription/service';
import { MedicineService } from '../components/search/medicineService';

export function mergeDrugInteractionsByMedicineId(interactions: MedicinesInteractions[]): MedicinesInteractions[] {
  const grouped = new Map<number, MedicinesInteractions>();

  for (const item of interactions) {
    const existing = grouped.get(item.medicineId);
    if (existing) {
      existing.drugInteractions = [...existing.drugInteractions, ...item.drugInteractions];
    } else {
      grouped.set(item.medicineId, { ...item, drugInteractions: [...item.drugInteractions] });
    }
  }

  return Array.from(grouped.values());
}
export interface InteractionStore {
  interactionId: string;
  setInteractionId(interactionId: string): void;

  medicineId: number;
  setMedicineId(medicineId: number): void;

  numberOfInteractions: number;
  setNumberOfInteractions(numberOfInteractions: number): void;

  medicineDrugInteractions: MedicinesInteractions[];

  setMedicineDrugInteractions: (medicineInteractions: MedicinesInteractions[]) => void;

  justifiedInteractions: PrescriptionInteractionJustifyDetail[];
  setJustifiedInteractions(interactions: PrescriptionInteractionJustifyDetail[]): void;
  updateJustifiedInteractions(interaction: PrescriptionInteractionJustifyDetail): void;
  loadingInteractions: boolean;
  fetchMedicineInteractions(prescriptionId: number): Promise<void>;
}

export const useInteractionStore = create<InteractionStore>()((set, get) => ({
  interactionId: '',
  medicineId: 0,
  numberOfInteractions: 0,
  setInteractionId(interactionId: string) {
    set((prev) => {
      return {
        ...prev,
        interactionId,
      };
    });
  },
  setMedicineId(medicineId: number) {
    set((prev) => {
      return {
        ...prev,
        medicineId,
      };
    });
  },
  setNumberOfInteractions(numberOfInteractions: number) {
    set((prev) => {
      return {
        ...prev,
        numberOfInteractions,
      };
    });
  },

  medicineDrugInteractions: [],

  setMedicineDrugInteractions: (medicineDrugInteractions) => {
    set((prev) => {
      return {
        ...prev,
        medicineDrugInteractions: mergeDrugInteractionsByMedicineId(medicineDrugInteractions),
      };
    });
  },

  justifiedInteractions: [],

  setJustifiedInteractions: (prescriptionInteractionJustifyDetail: PrescriptionInteractionJustifyDetail[]) => {
    set((prevState) => {
      return {
        ...prevState,
        justifiedInteractions: prescriptionInteractionJustifyDetail,
      };
    });
  },

  updateJustifiedInteractions: (interaction: PrescriptionInteractionJustifyDetail) => {
    set((prevState) => {
      const prevJustifiedInteractions = prevState.justifiedInteractions;

      const filteredInteraction = prevJustifiedInteractions.find(
        (item) => item.prescriptionInteractionJustificationId === interaction.prescriptionInteractionJustificationId
      );

      if (!filteredInteraction) return prevState;

      filteredInteraction.justification = interaction.justification;

      return {
        ...prevState,
        justifiedInteractions: prevJustifiedInteractions,
      };
    });
  },
  loadingInteractions: false,

  fetchMedicineInteractions: async (prescriptionId: number) => {
    if (get().loadingInteractions) return;

    try {
      set((prevState) => {
        return {
          ...prevState,
          loadingInteractions: true,
        };
      });

      const { medicineDrugInteraction, numberOfInteractions } = await MedicineService.fetchMedicineInteractions(
        prescriptionId
      );
      get().setMedicineDrugInteractions(mergeDrugInteractionsByMedicineId(medicineDrugInteraction));
      get().setNumberOfInteractions(numberOfInteractions);
    } catch (e) {
    } finally {
      set((prevState) => {
        return {
          ...prevState,
          loadingInteractions: false,
        };
      });
    }
  },
}));
